module.exports = __webpack_public_path__ + "img/h2.2daf2a65.jpg";